module.exports = __webpack_public_path__ + "img/date.4d1575a8.png";